{
  "header_title": "Product Bundles",
  "add_bundle": "Add Bundle",
  "refresh_prices_button": "Update all prices",
  "last_refreshed_notice": "Last updated: {{date}}",
  "filter": {
    "textsearchtitle": "Search",
    "textsearchplaceholder": "Search..."
  },
  "pagination": {
    "show": "Show"
  },
  "bundles_table": {
    "bundleBrand": "Bundle brand",
    "bundle_name": "Bundle name",
    "availability": "Availability",
    "sku": "SKU",
    "languages": "Languages",
    "sales_channels": "Sales channels",
    "main": "Main",
    "addons": "Addons",
    "variants_count_one": "{{count}} variant",
    "variants_count_other": "{{count}} variants",
    "insurance": "Insurance",
    "price_type": "Payment option",
    "price": "Sales price excluding VAT",
    "price_with_currency": "Sales price excluding VAT ({{currency}})",
    "vat": "VAT %",
    "available": "Available",
    "limited": "Limited",
    "noStock": "No stock",
    "price_updated": "Price last updated",
    "dynamic_pricing_not_setup_error": "Check TFAPs and/or IDs"
  },
  "button": {
    "edit_bundle": "Edit contents",
    "view_bundle": "View bundle"
  },
  "selected": {
    "bundleSelected_one": "{{count}} Bundle selected",
    "bundleSelected_other": "{{count}} Bundles selected",
    "removeFromSalesChannel": "Remove From Channel",
    "cancel": "Cancel",
    "updatePrice_one": "Update price",
    "updatePrice_other": "Update prices",
    "deleteBundle": "Delete",
    "editBundle": "Edit contents",
    "editSalesChannels": "Edit sales channels"
  },
  "delete_bundle_confirmation": {
    "title_one": "Delete {{count}} bundle",
    "title_other": "Delete {{count}} bundles",
    "content_one": "Are you sure you want to delete {{count}} bundle? The bundle will be completely deleted.",
    "content_other": "Are you sure you want to delete {{count}} bundles? Bundles will be completely deleted.",
    "buttons": {
      "cancel": "Cancel",
      "delete": "Delete",
      "accept": "Remove from channel"
    }
  },
  "notification": {
    "bundleDeleted_one": "{{count}} bundle deleted successfully",
    "bundleDeleted_other": "{{count}} bundles deleted successfully",
    "noAddedSalesChannels": "No sales channels currently sell this bundle",
    "bundleAddedToChannel": "Bundle added to sales channel",
    "salesChannelEdited": "Bundle's settings in sales channel saved",
    "removeFromChannel": "Remove a bundle from sales channel",
    "removeFromChannelLong": "Are you sure you want to remove {{bundleName}} from {{salesChannelName}}?",
    "refreshAllPricesSuccessful": "Price update request sent for all bundles in sales channel “{{salesChannelName}}”.",
    "refreshSelectedPricesSuccessful_one": "Price update request sent for {{count}} bundle in sales channel “{{salesChannelName}}”.",
    "refreshSelectedPricesSuccessful_other": "Price update request sent for {{count}} bundles in sales channel “{{salesChannelName}}”.",
    "refreshPricesFailed": "Price updated request failed."
  },
  "errors": {
    "addingSalesChannel": "Error occurred while adding sales channel",
    "editingSalesChannel": "Error occurred while editing sales channel",
    "deletingSalesChannel": "Error occurred while removing sales channel",
    "fetchBundleDetails": "Error occurred while fetching selected bundle details",
    "fetchPrices": "Error occurred while fetching bundle prices: {{- message}}",
    "unknownError": "Unknown error",
    "countryNotFound": "Country not found",
    "missingPrice": "Missing price",
    "missingPriceLong": "Use the product page to add a default price for this variant for {{countryName}}.",
    "materialCodeMissing": "Material code missing",
    "materialCodeMissingLong": "Use the product page to add a material code for this variant for {{countryName}}."
  },
  "editSalesChannels": {
    "currentlyAdded": "Sales channels that currently sell this bundle:",
    "notAdded": "Add this bundle to a sales channel:",
    "removeFromChannel": "Remove from channel",
    "acquisionPriceTitle": "Acquisition prices (TFAP) of bundle contents",
    "overrideDefaultPriceInfoText1": "To override the default price for this sales channel only, use these fields.",
    "overrideDefaultPriceInfoText2": "To edit the country-level default price, go to the product page.",
    "bundleLevelSettingsLabel": "Bundle-level sales settings",
    "paymentOptionLabel": "Payment option",
    "productVariantLabel": "Product variant",
    "defaultTFapLabel": "Default TFAP ({{currency}}) excl. VAT",
    "overrideTFapLabel": "Override TFAP ({{currency}}) excl. VAT",
    "includesInsuranceLabel": "Bundle includes insurance",
    "saveChanges": "Save changes",
    "addToChannel": "Add to channel",
    "cancel": "Cancel",
    "month": "month"
  }
}
